<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h1 class="title mb-6">{{ $t('settings') }}</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="8" class="mb-4 mb-sm-0">
        <box>
          <account-information
            hide-ether-wallet
            hide-neo-wallet
            v-model="accountInfo"
            :selected-roles="selectedRoles"
            :all-roles="roles"
            :errors="errors"
          />
          <div
            class="settings-form-bottom d-flex align-items-center flex-wrap-reverse"
          >
            <button
              class="btn btn-link-alt"
              @click.prevent="logoutFromAllDevices"
            >
              {{ $t('logoutFromAllDevices') }}
            </button>
            <b-button
              size="lg"
              variant="primary"
              @click="updateProfile"
              style="padding-left: 4rem; padding-right: 4rem;"
              class="ml-auto"
            >
              {{ $t('save') }}
            </b-button>
          </div>
        </box>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import editMixin from './../mixins/edit.js';

export default {
  mixins: [editMixin],

  data() {
    return {
      strongPassword: false
    };
  }
};
</script>
